export default __webpack_public_path__ + "static/SR France - Process Flow Chart - Burnt Sugars-b87c17f9fe76eb27cd2234b4d27fa9c9.pdf";